export const jobActionTypes = {
  GET_ALL_JOBS: '@job/GET_ALL_JOBS',
  GET_ALL_JOBS_START: '@job/GET_ALL_JOBS_START',
  GET_ALL_JOBS_ERROR: '@job/GET_ALL_JOBS_ERROR',

  GET_JOB_BY_ID: '@job/GET_JOB_BY_ID',
  GET_JOB_BY_ID_START: '@job/GET_JOB_BY_ID_START',
  GET_JOB_BY_ID_ERROR: '@job/GET_JOB_BY_ID_ERROR',

  SEND_JOB_INQUIRY: '@job/SEND_JOB_INQUIRY',
  SEND_JOB_INQUIRY_START: '@job/SEND_JOB_INQUIRY_START',
  SEND_JOB_INQUIRY_ERROR: '@job/SEND_JOB_INQUIRY_ERROR',

  SUBMIT_JOB_INQUIRY: '@job/SUBMIT_JOB_INQUIRY',
  SUBMIT_JOB_INQUIRY_START: '@job/SUBMIT_JOB_INQUIRY_START',
  SUBMIT_JOB_INQUIRY_ERROR: '@job/SUBMIT_JOB_INQUIRY_ERROR',

  CHANGE_JOB_INQUIRY: '@job/CHANGE_JOB_INQUIRY',
  CHANGE_JOB_INQUIRY_START: '@job/CHANGE_JOB_INQUIRY_START',
  CHANGE_JOB_INQUIRY_ERROR: '@job/CHANGE_JOB_INQUIRY_ERROR',
  CHANGE_JOB_INQUIRY_VALIDATION_ERROR:
    '@job/CHANGE_JOB_INQUIRY_VALIDATION_ERROR',

  UPDATE_JOB_INQUIRY: '@job/UPDATE_JOB_INQUIRY',
  UPDATE_JOB_INQUIRY_START: '@job/UPDATE_JOB_INQUIRY_START',
  UPDATE_JOB_INQUIRY_ERROR: '@job/UPDATE_JOB_INQUIRY_ERROR',

  ADD_JOB_INQUIRY_ROWS: '@job/ADD_JOB_INQUIRY_ROWS',
  ADD_JOB_INQUIRY_ROWS_START: '@job/ADD_JOB_INQUIRY_ROWS_START',
  ADD_JOB_INQUIRY_ROWS_ERROR: '@job/ADD_JOB_INQUIRY_ROWS_ERROR',

  DUPLICATE_JOB_INQUIRY_ROWS: '@job/DUPLICATE_JOB_INQUIRY_ROWS',
  DUPLICATE_JOB_INQUIRY_ROWS_START: '@job/DUPLICATE_JOB_INQUIRY_ROWS_START',
  DUPLICATE_JOB_INQUIRY_ROWS_ERROR: '@job/DUPLICATE_JOB_INQUIRY_ROWS_ERROR',

  CHANGE_JOB_SEARCH_REPORT: '@job/CHANGE_JOB_SEARCH_REPORT',
  CHANGE_JOB_SEARCH_REPORT_START: '@job/CHANGE_JOB_SEARCH_REPORT_START',
  CHANGE_JOB_SEARCH_REPORT_ERROR: '@job/CHANGE_JOB_SEARCH_REPORT_ERROR',
  CHANGE_JOB_SEARCH_REPORT_VALIDATION_ERROR:
    '@job/CHANGE_JOB_SEARCH_REPORT_VALIDATION_ERROR',

  UPDATE_JOB_SEARCH_REPORT: '@job/UPDATE_JOB_SEARCH_REPORT',
  UPDATE_JOB_SEARCH_REPORT_START: '@job/UPDATE_JOB_SEARCH_REPORT_START',
  UPDATE_JOB_SEARCH_REPORT_ERROR: '@job/UPDATE_JOB_SEARCH_REPORT_ERROR',

  ADD_JOB_SEARCH_REPORT_ROWS: '@job/ADD_JOB_SEARCH_REPORT_ROWS',
  ADD_JOB_SEARCH_REPORT_ROWS_START: '@job/ADD_JOB_SEARCH_REPORT_ROWS_START',
  ADD_JOB_SEARCH_REPORT_ROWS_ERROR: '@job/ADD_JOB_SEARCH_REPORT_ROWS_ERROR',

  DUPLICATE_JOB_SEARCH_REPORT_ROWS: '@job/DUPLICATE_JOB_SEARCH_REPORT_ROWS',
  DUPLICATE_JOB_SEARCH_REPORT_ROWS_START:
    '@job/DUPLICATE_JOB_SEARCH_REPORT_ROWS_START',
  DUPLICATE_JOB_SEARCH_REPORT_ROWS_ERROR:
    '@job/DUPLICATE_JOB_SEARCH_REPORT_ROWS_ERROR',

  CREATE_NEW_JOB: '@job/CREATE_NEW_JOB',
  CREATE_NEW_JOB_START: '@job/CREATE_NEW_JOB_START',
  CREATE_NEW_JOB_ERROR: '@job/CREATE_NEW_JOB_ERROR',

  GET_SEARCH_REPORT_JOBS: '@job/GET_SEARCH_REPORT_JOBS',
  GET_SEARCH_REPORT_JOBS_START: '@job/GET_SEARCH_REPORT_JOBS_START',
  GET_SEARCH_REPORT_JOBS_ERROR: '@job/GET_SEARCH_REPORT_JOBS_ERROR',

  RESET_JOB: '@job/RESET_JOB',

  ASSIGN_EMPLOYEES_TO_JOB: '@job/ASSIGN_EMPLOYEES_TO_JOB',
  ASSIGN_EMPLOYEES_TO_JOB_START: '@job/ASSIGN_EMPLOYEES_TO_JOB_START',
  ASSIGN_EMPLOYEES_TO_JOB_ERROR: '@job/ASSIGN_EMPLOYEES_TO_JOB_ERROR',

  ADD_TO_PRODUCT_START: '@job/ADD_TO_PRODUCT_START',
  ADD_TO_PRODUCT: '@job/ADD_TO_PRODUCT',
  ADD_TO_PRODUCT_ERROR: '@job/ADD_TO_PRODUCT_ERROR',

  SEND_TO_CLIENT_START: '@job/SEND_TO_CLIENT_START',
  SEND_TO_CLIENT: '@job/SEND_TO_CLIENT',
  SEND_TO_CLIENT_ERROR: '@job/SEND_TO_CLIENT_ERROR',

  DELETE_JOB_SEARCH_REPORT_ROWS: '@job/DELETE_JOB_SEARCH_REPORT_ROWS',
  DELETE_JOB_SEARCH_REPORT_ROWS_START:
    '@job/DELETE_JOB_SEARCH_REPORT_ROWS_START',
  DELETE_JOB_SEARCH_REPORT_ROWS_ERROR:
    '@job/DELETE_JOB_SEARCH_REPORT_ROWS_ERROR',

  DELETE_JOB_INQUIRY_ROWS: '@job/DELETE_JOB_INQUIRY_ROWS',
  DELETE_JOB_INQUIRY_ROWS_START: '@job/DELETE_JOB_INQUIRY_ROWS_START',
  DELETE_JOB_INQUIRY_ROWS_ERROR: '@job/DELETE_JOB_INQUIRY_ROWS_ERROR',

  CREATE_QUOTE: '@job/CREATE_QUOTE',
  CREATE_QUOTE_START: '@job/CREATE_QUOTE_START',
  CREATE_QUOTE_ERROR: '@job/CREATE_QUOTE_ERROR',

  DELETE_JOB_QUOTE_ROWS: '@job/DELETE_JOB_QUOTE_ROWS',
  DELETE_JOB_QUOTE_ROWS_START: '@job/DELETE_JOB_QUOTE_ROWS_START',
  DELETE_JOB_QUOTE_ROWS_ERROR: '@job/DELETE_JOB_QUOTE_ROWS_ERROR',

  ADD_JOB_QUOTE_ROWS: '@job/ADD_JOB_QUOTE_ROWS',
  ADD_JOB_QUOTE_ROWS_START: '@job/ADD_JOB_QUOTE_ROWS_START',
  ADD_JOB_QUOTE_ROWS_ERROR: '@job/ADD_JOB_QUOTE_ROWS_ERROR',

  DUPLICATE_JOB_QUOTE_ROWS: '@job/DUPLICATE_JOB_QUOTE_ROWS',
  DUPLICATE_JOB_QUOTE_ROWS_START: '@job/DUPLICATE_JOB_QUOTE_ROWS_START',
  DUPLICATE_JOB_QUOTE_ROWS_ERROR: '@job/DUPLICATE_JOB_QUOTE_ROWS_ERROR',

  SEND_JOB_QUOTE: '@job/SEND_JOB_QUOTE',
  SEND_JOB_QUOTE_START: '@job/SEND_JOB_QUOTE_START',
  SEND_JOB_QUOTE_ERROR: '@job/SEND_JOB_QUOTE_ERROR',

  CHANGE_JOB_QUOTE: '@job/CHANGE_JOB_QUOTE',
  CHANGE_JOB_QUOTE_START: '@job/CHANGE_JOB_QUOTE_START',
  CHANGE_JOB_QUOTE_ERROR: '@job/CHANGE_JOB_QUOTE_ERROR',
  CHANGE_JOB_QUOTE_VALIDATION_ERROR: '@job/CHANGE_JOB_QUOTE_VALIDATION_ERROR',

  UPDATE_JOB_QUOTE: '@job/UPDATE_JOB_QUOTE',
  UPDATE_JOB_QUOTE_START: '@job/UPDATE_JOB_QUOTE_START',
  UPDATE_JOB_QUOTE_ERROR: '@job/UPDATE_JOB_QUOTE_ERROR',

  DELETE_JOB_INQUIRY: '@job/DELETE_JOB_INQUIRY',
  DELETE_JOB_INQUIRY_START: '@job/DELETE_JOB_INQUIRY_START',
  DELETE_JOB_INQUIRY_ERROR: '@job/DELETE_JOB_INQUIRY_ERROR',
};
